module fdm.flightSegment {

    var diagnosticsZipMediaType = 'application/zip';

    function findDiagnosticsExportLink($filter: dgUtils.IFilterService, query: any): dg.restfulApi.Link {
        if (!query || !query.dgMeta || !query.dgMeta.links) {
            return null;
        }
        var links = $filter('dgLinksByRel')(query.dgMeta.links, [dg.restfulApi.DG_LINK_RELS.export, dg.restfulApi.DG_LINK_RELS.external]);
        for (var i = 0; i < links.length; i++) {
            var l = links[i];
            if (l.mediaType === diagnosticsZipMediaType && l.title === 'Export diagnostics' && !l.disabledReason) {
                return l;
            }
        }
        return null;
    }

    angular.module('fdm.flightSegment').directive('ecmDiagnosticsExport', ['$uibModal', '$filter',
        function ($uibModal: ng.ui.bootstrap.IModalService, $filter: dgUtils.IFilterService) {
            return {
                restrict: 'E',
                scope: {
                    query: '<'
                },
                link: function (scope: any, element: ng.IAugmentedJQuery) {
                    var toolbar: ng.IAugmentedJQuery = null;
                    var diagnosticsBtn: ng.IAugmentedJQuery = null;

                    var removeButton = function () {
                        if (diagnosticsBtn) {
                            diagnosticsBtn.remove();
                            diagnosticsBtn = null;
                        }
                    };

                    var openDiagnosticsModal = function (link: dg.restfulApi.Link) {
                        var seedQuery = scope.query
                            ? <dg.domain.IDomainObject>dgUtils.ObjectHelperService.mergeDeep({}, scope.query)
                            : null;

                        $uibModal.open({
                            controller: 'EcmDiagnosticsExportModalController',
                            templateUrl: '/app/src/flight-segment/ecm-diagnostics-export-modal.html',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                exportLink: function () { return angular.extend({}, link); },
                                seedQuery: function () { return seedQuery; }
                            }
                        });
                    };

                    var syncButton = function () {
                        removeButton();
                        var diagLink = findDiagnosticsExportLink($filter, scope.query);
                        if (!diagLink) {
                            return;
                        }
                        if (!toolbar || !toolbar.length) {
                            toolbar = angular.element(document.querySelector('.view-heading .dg-exports-toolbar'));
                        }
                        if (!toolbar || !toolbar.length) {
                            return;
                        }

                        diagnosticsBtn = angular.element('<button type="button" class="btn btn-info btn-export"></button>');
                        diagnosticsBtn.append(angular.element('<i class="icon-left"></i>'));
                        diagnosticsBtn.append(angular.element('<span></span>').text(diagLink.title || 'Export diagnostics'));
                        diagnosticsBtn.on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            scope.$apply(function () { openDiagnosticsModal(diagLink); });
                        });
                        toolbar.append(diagnosticsBtn);
                    };

                    scope.$watch('query', syncButton, true);

                    scope.$on('$destroy', function () {
                        removeButton();
                    });

                    element.css('display', 'none');

                    scope.$evalAsync(syncButton);
                }
            };
        }]);
}
